const CountryExposureChart = require('./CountryExposureChart');

module.exports = CountryExposureChart;
